"use strict";

exports.__esModule = true;
exports.SelectedDevicesController = SelectedDevicesController;
exports.getSelectedDevices = getSelectedDevices;
exports.useSelectedDevices = void 0;
var _react = _interopRequireDefault(require("react"));
var _URLFilter = require("../../Core/URLFilter");
var _DeviceListContext = require("../DeviceListContext");
var _DeviceContext = require("../DeviceContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var flatten = require("ramda").flatten;
function getSelectedDevices(props) {
  var dataRange = props.dataRange,
    selection = props.selection,
    _props$defaultDeviceL = props.defaultDeviceList,
    defaultDeviceList = _props$defaultDeviceL === void 0 ? [] : _props$defaultDeviceL,
    deviceContext = props.deviceContext,
    urlFilter = props.urlFilter;

  // If device context is present, return it
  if (deviceContext) {
    return [deviceContext.uuid];
  }

  // If selection context has device, then use it
  if (dataRange && selection && dataRange === "SELECTION" && selection.selected && selection.selected.device) {
    return flatten([selection.selected.device]);
  }

  // If selection context has deviceList, filter for the devices from defaultDeviceList
  // Note: Is the filter needed? Won't the selection context be set from defaultDeviceList?
  if (selection && selection.selected && selection.selected.deviceList) {
    // $FlowIgnore
    return defaultDeviceList.filter(function (device) {
      return selection.selected.deviceList.includes(device.uuid);
    }).map(function (_ref) {
      var uuid = _ref.uuid;
      return uuid;
    });
  }

  // From url filter
  var device = flatten([urlFilter.filters.device]);
  if (device.length > 0) {
    return device;
  }

  // No device from url context, so return default list of devices
  // $FlowIgnore
  return defaultDeviceList.map(function (_ref2) {
    var uuid = _ref2.uuid;
    return uuid;
  });
}
function SelectedDevicesController(props) {
  var device = useSelectedDevices();
  return props.children(device);
}
var useSelectedDevices = exports.useSelectedDevices = function useSelectedDevices() {
  var deviceContext = _react["default"].useContext(_DeviceContext.DeviceContext);
  if (deviceContext) {
    // for single device grid
    return [deviceContext.uuid];
  }
  var urlFilter = _react["default"].useContext(_URLFilter.URLFilterContext);
  var devicesList = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var _urlFilter$filters = urlFilter.filters,
    tags = _urlFilter$filters.tags,
    deviceTypes = _urlFilter$filters.deviceTypes,
    deviceUuids = _urlFilter$filters.device;
  var device = Array.isArray(deviceUuids) ? deviceUuids : [deviceUuids];
  var filteredDevices = devicesList;
  if (devicesList) {
    if (deviceUuids.length > 0) {
      filteredDevices = devicesList.filter(function (x) {
        return deviceUuids.includes(x.uuid);
      });
    }
    if (tags && tags.length > 0) {
      filteredDevices = filteredDevices.filter(function (device) {
        return device.tags.some(function (tag) {
          return tags.includes(tag);
        });
      });
    }
    if (deviceTypes && deviceTypes.length > 0) {
      filteredDevices = filteredDevices.filter(function (device) {
        return Array.isArray(deviceTypes) && deviceTypes.length ? deviceTypes.includes(device.deviceType) : true;
      });
    }
    device = filteredDevices.map(function (x) {
      return x.uuid;
    });
  }
  return device;
};